
<template>
    <div class="bg-gray-800 text-white">
        <p v-show="error">{{ error }}</p>

        <div>

            <div class="grid grid-rows-6 grid-flow-col gap-4 h-screen">

                <!-- 1 -->
                <div style="grid-area: 1 / 1 / 2 / 2;">
                    <floor-events-panel-header :theme="group_id === '131' ? 'spk-leipzig' : 'default'" :floor="floor.name"></floor-events-panel-header>
                </div>
                <!-- 2 -->

                <div
                    v-if="events.length > 0"
                    v-for="(meeting, key) in events"
                    style="grid-area: 2 / 1 / 6 / 2;"
                    :id="'event_list_'+key"
                    :style="key === page ? 'opacity: 1; visibility: visible; transition: opacity 250ms ease-in;' : 'opacity: 0; visibility: hidden;'"
                >
                    <div class="grid grid-flow-col text-2xl ml-20 mr-20 pb-10 gap-5 mt-10 max-h-full"
                         :style="'grid-template-rows: repeat('+grid.y+', minmax(0, 1fr));'"
                    >
                        <div v-for="event in meeting" class="grid">
                            <span><strong>{{event.event_title ?? '-'}}</strong></span>
                            <span>{{event.conference_room}}</span>
                            <span :class="event.status === 'ongoing' ? 'text-red-500' : ( event.status === 'upcoming' ? 'text-yellow-400' : 'text-green-500')">{{event.start | time}} - {{event.end | time}}</span>
                        </div>
                    </div>
                    <div class="absolute bottom-0 right-0 mr-20 mb-28 text-right"> Seite {{key + 1}} / {{events.length}}</div>
                </div>

                <div
                    v-if="events.length === 0"
                    style="grid-area: 2 / 1 / 6 / 2;"
                >
                    <div class="w-full h-full text-center flex">
                        <span class="mr-auto ml-auto mt-auto mb-auto text-2xl">Derzeit finden keine Veranstaltungen statt.</span>
                    </div>
                </div>

                <!-- 3 -->

                <div style="grid-area: 6 / 1 / 7 / 2;" class="flex justify-center">
                    <div class="flex mx-4 items-center">
                        <div class="w-4 h-4 rounded-full mr-2 bg-red-500"></div>
                        Laufende Veranstaltung
                    </div>
                    <div class="flex mx-4 items-center">
                        <div class="w-4 h-4 rounded-full mr-2 bg-yellow-400"></div>
                        Demnächst anstehende Veranstaltung
                    </div>
                    <div class="flex mx-4 items-center">
                        <div class="w-4 h-4 rounded-full mr-2 bg-green-500"></div>
                        Später anstehende Veranstaltung
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";

export default {
    name: "FloorEventsPanel",
    components: {Loading},

    props: [
        'id',
        'group_id'
    ],

    data: () => ({
        loading: false,
        error: '',
        events:[],
        floor:{},
        grid: {
            x: 3,
            y: 4
        },
        page: 0,
    }),

    mounted() {
        this.load();
        this.timer = setInterval(this.load, 60000);

        setInterval(this.paginate, 15000);
    },

    computed: {

    },

    methods: {
        load() {
            this.currentDate = new Date().toISOString().slice(5, 10);
            this.error = '';
            this.loading = true;
            this.$http.get(`/panel-data/floors/${this.id}/events`)
                .then((result) => {
                    this.events = result.data.events;
                    this.floor = result.data.floor;
                    this.grid = result.data.grid;
                    this.loading = false;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });

        },

        paginate(){
            this.page ++;

            if(this.page >= this.events.length){
                this.page = 0;
            }
        }
    },

    filters: {
        time(val) {
            return val.substr(11, 5);
        },
        date(val) {
            let [y, m, d] = val.substr(0, 10).split('-');
            return `${d}.${m}.${y}`;
        },
        dayOfWeek(val) {
            let [y, m, d] = val.substring(0, 10).split('-');
            return new Date(`${y}-${m}-${d}`).toLocaleString('de-de', {  weekday: 'short' });
        }
    },
}
</script>

<style scoped>
/* Layout */
.bg-gray-800 {
    background-color: #1f2937;
}
.text-white {
    color: #ffffff;
}
.grid {
    display: -ms-grid;
    display: grid;
}
.grid-rows-6 {
    -ms-grid-rows: (minmax(0, 1fr))[6];
    grid-template-rows: repeat(6, minmax(0, 1fr));
}
.grid-flow-col {
    grid-auto-flow: column;
}
.gap-4 {
    gap: 1rem;
}
.gap-5 {
    gap: 1.25rem;
}
.h-screen {
    height: 100vh;
}
.h-full {
    height: 100%;
}
.w-full {
    width: 100%;
}
.w-4 {
    width: 1rem;
}
.h-4 {
    height: 1rem;
}
.max-h-full {
    max-height: 100%;
}

/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.justify-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/* Positioning */
.absolute {
    position: absolute;
}
.bottom-0 {
    bottom: 0;
}
.right-0 {
    right: 0;
}

/* Spacing */
.ml-20 {
    margin-left: 5rem;
}
.mr-20 {
    margin-right: 5rem;
}
.mt-10 {
    margin-top: 2.5rem;
}
.pb-10 {
    padding-bottom: 2.5rem;
}
.mb-28 {
    margin-bottom: 7rem;
}
.mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mr-auto {
    margin-right: auto;
}
.ml-auto {
    margin-left: auto;
}
.mt-auto {
    margin-top: auto;
}
.mb-auto {
    margin-bottom: auto;
}

/* Typography */
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}

/* Colors */
.text-red-500 {
    color: #ef4444;
}
.text-yellow-400 {
    color: #facc15;
}
.text-green-500 {
    color: #22c55e;
}
.bg-red-500 {
    background-color: #ef4444;
}
.bg-yellow-400 {
    background-color: #facc15;
}
.bg-green-500 {
    background-color: #22c55e;
}

/* Border */
.rounded-full {
    -webkit-border-radius: 9999px;
    -moz-border-radius: 9999px;
    border-radius: 9999px;
}
</style>